/**
 * Utility functions for formatting social media links
 */

/**
 * Formats TikTok links to ensure account names have exactly one @ prefix
 * @param url - The URL to format
 * @param platform - Optional platform identifier (if available)
 * @returns The formatted URL
 */
export const formatTikTokLink = (url: string, platform?: string): string => {
  // If platform is provided and it's not TikTok, return URL unchanged
  if (platform && platform.toLowerCase() !== 'tiktok') {
    return url;
  }
  
  // If platform is not provided, detect TikTok by URL pattern
  if (!platform && !url.includes('tiktok.com')) {
    return url;
  }
  
  let fixedUrl = url;

  // 1) Fix URLs with double @ symbols: tiktok.com/@@username -> tiktok.com/@username
  fixedUrl = fixedUrl.replace(/tiktok\.com\/@@/g, 'tiktok.com/@');

  // 2) Ensure single @ prefix exists after domain (tiktok.com/username -> tiktok.com/@username)
  fixedUrl = fixedUrl.replace(
    /(tiktok\.com\/)((?!@)[^\/]+)(\/.*)?/i,
    (_match, domainPart: string, account: string, rest: string = '') => {
      return `${domainPart}@${account}${rest}`;
    }
  );

  return fixedUrl;
};

/**
 * General link formatter that applies platform-specific formatting
 * @param url - The URL to format
 * @param platform - Optional platform identifier
 * @returns The formatted URL
 */
export const formatSocialMediaLink = (url: string, platform?: string): string => {
  // Apply TikTok-specific formatting
  return formatTikTokLink(url, platform);
}; 